import api from '@/services/api'
import { AxiosRequestConfig } from 'axios'
import { GetUserByTokenResponse } from './types'
import { RebrandedBrandColors } from '@conexasaude/conexa-hero'

class AuthService {
  static async getClinicRebrandedColorsById(
    clinicId: number,
  ): Promise<RebrandedBrandColors> {
    return api
      .get(`/whitelabel/config/cores/${clinicId}/v2`)
      .then(res => res.data.object)
      .catch(() => {
        return null
      })
  }

  static async getClinicRebrandedColorsByUniqueCode(
    uniqueCode: string,
  ): Promise<RebrandedBrandColors> {
    return api
      .get(`/whitelabel/config/cores/codigo_unico/${uniqueCode}/v2`)
      .then(res => res.data.object)
      .catch(() => {
        return null
      })
  }

  static async getUserByToken(token: string): Promise<GetUserByTokenResponse> {
    const { data } = await api.get(`/usuario/auth/redirecionamento/${token}`)
    return data.object
  }

  static async sendChangePasswordEmail(
    email: string,
    config?: AxiosRequestConfig,
  ): Promise<boolean> {
    const { data } = await api.post(
      '/usuario/esqueciSenha/paciente',
      {
        email,
      },
      config,
    )
    return data
  }
}

export default AuthService
